import { render, staticRenderFns } from "./QuickRecentMediaWindow.vue?vue&type=template&id=2183eaa8&"
import script from "./QuickRecentMediaWindow.vue?vue&type=script&lang=js&"
export * from "./QuickRecentMediaWindow.vue?vue&type=script&lang=js&"
import style0 from "./QuickRecentMediaWindow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports